/**
 * Renders the global toast. Mount once at app root (e.g. in App.tsx).
 * State is driven by useToastStore; import showToast from components/toast/toastStore in components.
 */
import React from 'react';
import { Toast } from '../common/Toast';
import { useToastStore } from './toastStore';

export function ToastRoot() {
  const message = useToastStore(s => s.message);
  const visible = useToastStore(s => s.visible);
  const variant = useToastStore(s => s.variant);
  const hide = useToastStore(s => s.hide);
  const duration = useToastStore(s => s.duration);

  return (
    <Toast
      message={message}
      visible={visible}
      onHide={hide}
      duration={duration}
      variant={variant}
    />
  );
}
